import { HttpService } from '@/services/http.ts'
import type { Role } from '@/services/models.ts'

export interface LoginEmailPassword {
  email: string
  password: string
}

export interface ValidateOtp {
  temp_auth_token: string
  otp: string
}

interface JwtTokens {
  access: string
  refresh: string
  roles: Role[]
  user: {
    id: string
    email: string
    first_name: string
    last_name: string
    picture: string
  }
}

interface RequestEmailOTP {
  otp_use_email: boolean
  temp_auth_token: string
}

export interface GoogleLogin {
  token: string
}

export class AuthApi {
  static async loginEmailPassword(payload: LoginEmailPassword): Promise<RequestEmailOTP> {
    return HttpService.post('/auth/login/', payload)
  }

  static async resendOtpCode(payload: { temp_auth_token: string }): Promise<void> {
    return HttpService.post('/otp/request/', payload)
  }

  static async validateOtp(payload: ValidateOtp): Promise<JwtTokens> {
    return HttpService.post('/auth/otp/', payload)
  }

  static async requestPasswordReset(payload: { email: string }): Promise<void> {
    return HttpService.post('/auth/reset_password/', payload)
  }

  static async resetPassword(payload: { uid: string, token: string, password_1: string, password_2: string }): Promise<void> {
    return HttpService.post('/auth/reset_password/confirm/', payload)
  }

  static async googleLogin(payload: GoogleLogin): Promise<JwtTokens> {
    return HttpService.post('/sso/google/', payload, {})
  }

  static async oktaRedirect(payload: {email: string}): Promise<{url: string, internal: string}> {
    return HttpService.post('/sso/okta/redirect/', payload)
  }

  static async oktaCallback(payload: { code: string, state: string, internal: string }): Promise<JwtTokens> {
    return HttpService.post('/sso/okta/callback/', payload, {})
  }

  static async entraRedirect(payload: {email: string}): Promise<{url: string, internal: string}> {
    return HttpService.post('/sso/entra/redirect/', payload)
  }

  static async entraCallback(payload: { code: string, state: string, internal: string }): Promise<JwtTokens> {
    return HttpService.post('/sso/entra/callback/', payload, {})
  }

  /** Start a bank's SSO without knowing the user yet (deep links): the backend picks the bank's IdP. */
  static async ssoRedirectByBank(payload: { bank: string, provider?: 'okta' | 'entra' }): Promise<{url: string, internal: string}> {
    return HttpService.post('/sso/redirect/', payload)
  }
}
